import React, { HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

type Props = HTMLAttributes<HTMLParagraphElement>

const PageSubtitle: React.FC<Props> = ({ children, className, ...props }) => (
  <p
    className={cn('text-muted-foreground mb-4 text-[14px]', className)}
    {...props}
  >
    {children}
  </p>
)

export default PageSubtitle
